import React, { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import { FORM_FIELDS_MAP } from 'features/sendouts/components/drawers/CreateSendoutDrawer/SendoutForm/SendoutForm.constants';
import strings from 'strings';
import { TimeSelect } from 'UI/components/molecules/TimeSelect';
import { REQUIRED_VALIDATION } from 'UI/utils';

import { getSuggestedInterviewTimes } from '../utils';

const STRINGS = strings.sendouts.form;

export const FixedHourFields = () => {
  const { control, errors } = useFormContext();
  const { from: suggestedTime } = useMemo(getSuggestedInterviewTimes, []);

  return (
    <>
      <Grid item xs={6}>
        <Controller
          name={FORM_FIELDS_MAP.InterviewFromHour.key}
          control={control}
          rules={REQUIRED_VALIDATION}
          defaultValue={suggestedTime}
          as={
            <TimeSelect
              error={!!errors[FORM_FIELDS_MAP.InterviewFromHour.key]}
              errorText={errors[FORM_FIELDS_MAP.InterviewFromHour.key]?.message}
              name={FORM_FIELDS_MAP.InterviewFromHour.key}
              placeholder={STRINGS.labels.hour}
            />
          }
        />
      </Grid>
    </>
  );
};
